import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=79b62738&scoped=true&"
import script from "./Connection.vue?vue&type=script&lang=ts&"
export * from "./Connection.vue?vue&type=script&lang=ts&"
import style0 from "./Connection.vue?vue&type=style&index=0&id=79b62738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b62738",
  null
  
)

export default component.exports